export default __webpack_public_path__ + "static/media/news-detail-1.7cdd0995.png";